import { Search, Bell } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function Header({ onSearch }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const initial = user && user.name ? user.name.charAt(0).toUpperCase() : "M";

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 bg-bg/85 backdrop-blur-xl border-b border-white/5
                 flex items-center justify-between px-4 py-3"
    >
      <Link to="/" data-testid="logo-link" className="font-heading font-extrabold text-2xl tracking-tight select-none">
        Desh<span className="text-white">Flix</span>
        <sup className="text-brand text-[10px] font-bold tracking-widest ml-0.5">BD</sup>
      </Link>
      <div className="flex items-center gap-2">
        <button
          data-testid="header-search-btn"
          onClick={() => (onSearch ? onSearch() : navigate("/search"))}
          className="w-10 h-10 rounded-full grid place-items-center text-white/80 hover:bg-white/5 transition"
          aria-label="Search"
        >
          <Search size={20} />
        </button>
        <button
          data-testid="header-notifications-btn"
          className="w-10 h-10 rounded-full grid place-items-center text-white/80 hover:bg-white/5 transition relative"
          aria-label="Notifications"
        >
          <Bell size={20} />
          <span className="absolute top-2 right-2 w-1.5 h-1.5 bg-brand rounded-full" />
        </button>
        <Link
          to={user ? "/profile" : "/login"}
          data-testid="header-avatar"
          className="w-10 h-10 rounded-full bg-gradient-to-br from-brand to-orange-500 grid place-items-center text-white font-semibold text-sm shadow-lg shadow-brand/30"
        >
          {user ? initial : "M"}
        </Link>
      </div>
    </header>
  );
}
